import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {Login} from '../../../modelo/usuario/login';
import {SubscriptionLike} from 'rxjs';
import {Producto} from '../../../modelo/producto/producto';
import {UserloginService} from '../../../servicios/usuario/userlogin.service';
import {ProductoService} from '../../../servicios/producto/producto.service';

@Component({
  selector: 'app-producto-relacionado',
  templateUrl: './producto-relacionado.component.html',
  styleUrls: ['./producto-relacionado.component.css']
})
export class ProductoRelacionadoComponent implements OnInit,OnDestroy {
  public currentUser: Login;
  private subs: SubscriptionLike[];
  public productos: Producto[];
  public idUsuario:number=0;
  public clicodigo: string='';
  @Input() linea:string;
  @Input() tipoProd:string;
  @Input() mostrar:boolean=true;
  constructor(private userLogin: UserloginService, private prodSV: ProductoService) {
    this.currentUser = null;
    this.subs = [];
    this.productos = [];
  }

  ngOnInit(): void {
    this.currentUser = this.userLogin.getCurrentSession();
    this.clicodigo = this.currentUser != null ? this.currentUser.cliCodigo : '0';
    this.idUsuario = this.currentUser != null ? parseInt(this.currentUser.idUsuario) : 0;
    this.subs.push(
      this.prodSV.traerProductosTop(this.tipoProd,this.linea, this.clicodigo).subscribe(res => {
        this.productos = res.data;
      })
    );
  }

  ngOnDestroy(): void {
  }

}
